import React from 'react';
import BaseIcon from './BaseIcon';


const TriangleDropDownIcon = props => (
  <BaseIcon {...props} width={10} height={5}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-629.000000, -2970.000000)" fill="#212D42">
        <polygon points="629 2970 639 2970 634 2975" />
      </g>
    </g>
  </BaseIcon>
);

export default TriangleDropDownIcon;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Icons/TriangleDropDownIcon.jsx